import { css } from '@emotion/react'
import { Link } from 'gatsby'
import React from 'react'
import useScrollDirection from '../hooks/useScrollDirection'

const headerCss = {
  self: {
    up: css({
      position: 'sticky',
      zIndex: 2,
      top: 0,
      borderBottom: '1px solid var(--light-midnight)',
    }),
    down: css({
      display: 'none',
    }),
  },
  ul: css({
    display: 'flex',
    listStyle: 'none',
    padding: '8px 16px',
    margin: '0 auto',
    maxWidth: 768,
    li: {
      padding: '0 8px',
      ':not(:last-child)': {
        borderRight: '1px solid var(--light-midnight)',
      },
    },
  }),
}

const routes = [
  { name: 'Головна', url: '/' },
  { name: 'Стріми', url: '/streams/' },
  { name: 'Про мене', url: '/about/' },
] as const

export default function Header() {
  const scrollDirection = useScrollDirection()

  return (
    <header
      css={scrollDirection === 'down' ? headerCss.self.down : headerCss.self.up}
    >
      <nav>
        <ul css={headerCss.ul}>
          {routes.map(({ name, url }) => (
            <li key={url}>
              <Link to={url}>{name}</Link>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  )
}
